import { Dayjs } from "dayjs";
import { ApiError } from "../../../types/api-error";

export type OrderAddRequestBody = {
  opis_uslugi: string;
  termin_rozpoczecia: Dayjs | string | null; //pole obowiązkowe
  termin_zakonczenia: Dayjs | string | null; //pole obowiązkowe
  kraj: string;
  wojewodztwo: string;
  kod_pocztowy: string;
  miasto: string;
  szerokosc_geograficzna: number;
  dlugosc_geograficzna: number;
  miejsce: StoragePlace | undefined;
  skladowanie_plaskie: boolean;
  wysokie_skladowanie: boolean;
  polki: boolean;
  warunek_temperaturowy: StorageTemperatureCondition | undefined;
  rodzaj_towaru: StorageGoodsType | undefined;
  opis_towaru: string | null;
  specjalny_sprzet: string | null;
  dodatkowe_uwagi: string | null;
  uslugi_zamowione:
    | {
        cel_zamowienia: StorageMethod | undefined;
        uslugi_dodatkowe?: (StorageMethod | undefined)[];
        ilosc_dodatkowych: number;
      }
    | undefined;
  przedmioty_skladowania: StorageArticles[] | undefined;

  klient: PurchaserData | null;
  email_operatora: string | null;
};

export type StorageArticles = {
  rodzaj_opakowania: PackageType | undefined;
  dodatkowe_info: string | null;
  ilosc: number;
  waga: number;
  dlugosc: number;
  szerokosc: number;
  wysokosc: number;
  rozmiar: number;
  jednostka_wagi: WeightUnit;
  jednostka_dlugosci: DistanceUnit;
};
export type PurchaserData = {
  nazwa: string;
  nip: string;
  telefon: string;
  email: string;
  info_dodatkowe: string;
  adres_klienta: PurchaserAddress | null;
};
export type PurchaserAddress = {
  kod_pocztowy: string;
  miejscowosc_poczty: string;
  miejscowosc: string;
  ulica: string;
  numer_budynku: string;
  numer_lokalu: string;
  wojewodztwo: string;
  kraj: string;
  szerokosc_geograficzna: number | null;
  dlugosc_geograficzna: number | null;
};
export type OrderAddResponse = {
  result: boolean;
  error_code: ApiError;
  payload: {
    id_zamowienie: string;
    numer_zamowienia: string;
  };
  errors_debug: string[];
};
export enum StorageMethod {
  Skladowanie = 0,
  Crossdocking = 1,
  Fullfilment = 2,
  Etykietowanie = 3,
  Pakowanie = 4,
  Sortowanie = 5,
  ECommerce = 6,
  Wysylka = 7,
  Inne = 8,
}
export enum StoragePlace {
  Inside = 0,
  Outside = 1,
}
export enum StorageTemperatureCondition {
  Nieogrzewany = 0,
  Chlodnia = 1,
  Ogrzewanie = 2,
  TemperatureControl = 3,
}

export enum StorageGoodsType {
  Neutralny = 0,
  Medyczne = 1,
  Spozywcze = 2,
  DuzeADR = 3,
  Inne = 4,
}

export enum PackageType {
  EURPallet = 2,
  HalfEurPallet = 3,
}

export enum WeightUnit {
  Kg = 0,
  Tona = 1,
  Dkg = 2,
}

export enum DistanceUnit {
  M = 0,
  Cm = 1,
  Mm = 2,
}
